import axios from 'axios'
import QS from 'qs';
import baseUrl from "./baseUrl";
import * as qiniu from 'qiniu-js';
import "vant/lib/toast/style"
import Toast from "vant/lib/toast";

//请求超时时间。例如超过了10s，就会告知用户当前请求超时
axios.defaults.timeout = 10000
//axios默认请求头发起post的请求会发两遍，修改请求头后通过qs模块将数据处理后发送服务端
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
axios.defaults.headers.common["user-token"] = localStorage.getItem("user-token");
axios.defaults.headers.common["user-ip"] = returnCitySN.cip;

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function getData(url, params) {
    axios.defaults.headers.common["user-token"] = localStorage.getItem("user-token");
    axios.defaults.headers.common["user-ip"] = returnCitySN.cip;
    return new Promise((resolve, reject) => {
        axios.get(url, {
            params: params
        })
            .then(res => {
                resolve(res);
            })
            .catch(err => {
                reject(err)
            })
    });
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function postData(url, params, header = []) {
    axios.defaults.baseURL = '/api'
    axios.defaults.headers.common["user-token"] = localStorage.getItem("user-token");
    axios.defaults.headers.common["user-ip"] = returnCitySN.cip;
    if (header && typeof header == 'object') {
        for (var i in header) {
            axios.defaults.headers.common[i] = header[i];
        }
    }
    var member_id = localStorage.getItem("member-id");
    if (!params) {
        params = {}
    }
    if (member_id) {
        params.member_id = member_id;
    } else {
        params.member_id = 106351;
        //axios.defaults.headers.common["user-token"]="38b3ae6e6c814d31e69dab94c28aa3c06bcc042c"
    }
    return new Promise((resolve, reject) => {
        axios.post(url, QS.stringify(params))
            .then(res => {
                if (res.data.status === 1100) {
                    Toast.fail(res.data.message);
                    return;
                }
                //未登录状态
                if (res.data.status === 1000) {
                    var callback = encodeURIComponent(window.location.href);
                    window.location.href = res.data.data.url + "&callback=" + callback;
                } else {
                    resolve(res);
                }
            })
            .catch(err => {
                resolve(err.response)
            })
    });
}

//七牛云 上传凭证接口
export function qiniuPost(data, that, item, callback) {
    console.log(data.file)
    var _this = this;
    var param = {
        file_name: data.file.name,
    };
    var file_size = 0;
    var config = {
        useCdnDomain: true,
        region: qiniu.region.z2
    };
    postData('/admin/upload/getToken', param).then(res => {
        var observable = qiniu.upload(
            data.file,
            res.data.data.key,
            res.data.data.uptoken,
            {
                fname: data.file.name,
                params: {},
                mimeType: [],
            },
            {
                useCdnDomain: true,
            },
        );
        observable.subscribe({
            next(res) {
                console.log('next');
                console.log(res);
                file_size = res.total.size;
            },
            error(err) {
                console.log('error:');
                console.log(err);
                data.onSuccess();
                console.log('error//');
            },
            complete(sub_res) {
                //根据上传成功信息返回图片
                var file_url = res.data.data.domain + res.data.data.key;
                data.onSuccess({"type": item, "file_url": file_url});
                that[item] = file_url;
                if (typeof that.ruleForm != 'undefined') {
                    that.ruleForm[item] = file_url;
                }
                if (callback) {
                    callback && callback(file_url, that);
                } else {
                    that.$loading().close();
                }
            }
        })
    });
}

//七牛云 上传凭证接口
export function qiniuPostNew(data, callback) {
    var _this = this;
    var param = {
        file_name: data.file.name,
    };
    var file_size = 0;
    var config = {
        useCdnDomain: true,
        region: qiniu.region.z2
    };
    postData('/agent/index/upImageToken', param).then(res => {
        var observable = qiniu.upload(
            data.file,
            res.data.data.key,
            res.data.data.uptoken,
            {
                fname: data.file.name,
                params: {},
                mimeType: [],
            },
            {
                useCdnDomain: true,
            },
        );
        observable.subscribe({
            next(res) {
                console.log('next');
                console.log(res);
                file_size = res.total.size;
            },
            error(err) {
                console.log('error:');
                console.log(err);
                data.onSuccess();
                console.log('error//');
            },
            complete(sub_res) {
                //根据上传成功信息返回图片
                var file_url = res.data.data.domain + res.data.data.key;
                data.onSuccess({"file_url": file_url});
                console.log("上传成功，正在返回地址")
                callback(file_url);
                // that.$loading().close();
            }
        })
    });
}



// WEBPACK FOOTER //
// ./src/wap/assets/js/httpRequest.js